import { apiClient } from './api';
import type {
  TenantAthleteBillingResponse,
  TenantPackagePlan,
  TenantPackagePlanPayload,
  TenantBillingOverviewResponse,
  TenantPackageSalePayload,
  TenantManualBookingPaymentPayload,
  TenantSessionCharge,
  TenantSessionChargeNotReceivedPayload,
  TenantSessionChargeRequestPayload,
  TenantUsePackageCreditPayload,
} from '../types';

export async function getTenantBillingOverview(): Promise<TenantBillingOverviewResponse> {
  const response = await apiClient.get<TenantBillingOverviewResponse>('/api/v1/web/tenant-billing/overview');
  return response.data;
}

export async function getTenantAthleteBilling(athleteId: number): Promise<TenantAthleteBillingResponse> {
  const response = await apiClient.get<TenantAthleteBillingResponse>(`/api/v1/web/tenant-billing/athletes/${athleteId}`);
  return response.data;
}

export async function createTenantPackagePlan(payload: TenantPackagePlanPayload): Promise<TenantPackagePlan> {
  const response = await apiClient.post<TenantPackagePlan>('/api/v1/web/tenant-billing/package-plans', payload);
  return response.data;
}

export async function recordTenantPackageSale(
  athleteId: number,
  payload: TenantPackageSalePayload
): Promise<TenantAthleteBillingResponse> {
  const response = await apiClient.post<TenantAthleteBillingResponse>(
    `/api/v1/web/tenant-billing/athletes/${athleteId}/packages`,
    payload
  );
  return response.data;
}

export async function recordManualBookingPayment(
  bookingId: number,
  payload: TenantManualBookingPaymentPayload
): Promise<TenantAthleteBillingResponse> {
  const response = await apiClient.post<TenantAthleteBillingResponse>(
    `/api/v1/web/tenant-billing/bookings/${bookingId}/manual-payment`,
    payload
  );
  return response.data;
}

export async function requestTenantSessionCharge(
  bookingId: number,
  payload: TenantSessionChargeRequestPayload
): Promise<TenantSessionCharge> {
  const response = await apiClient.post<TenantSessionCharge>(
    `/api/v1/web/tenant-billing/bookings/${bookingId}/charge`,
    payload
  );
  return response.data;
}

export async function confirmTenantSessionCharge(
  bookingId: number,
  chargeId: number
): Promise<TenantSessionCharge> {
  const response = await apiClient.post<TenantSessionCharge>(
    `/api/v1/web/tenant-billing/bookings/${bookingId}/charge/${chargeId}/confirm`
  );
  return response.data;
}

export async function markTenantSessionChargeNotReceived(
  bookingId: number,
  chargeId: number,
  payload: TenantSessionChargeNotReceivedPayload
): Promise<TenantSessionCharge> {
  const response = await apiClient.post<TenantSessionCharge>(
    `/api/v1/web/tenant-billing/bookings/${bookingId}/charge/${chargeId}/not-received`,
    payload
  );
  return response.data;
}

export async function useBookingPackageCredit(
  bookingId: number,
  payload?: TenantUsePackageCreditPayload
): Promise<TenantAthleteBillingResponse> {
  const response = await apiClient.post<TenantAthleteBillingResponse>(
    `/api/v1/web/tenant-billing/bookings/${bookingId}/use-package-credit`,
    payload ?? {}
  );
  return response.data;
}
